import { render, staticRenderFns } from "./reporteHuellaCarbono.vue?vue&type=template&id=8b104d6a&scoped=true&"
import script from "./reporteHuellaCarbono.vue?vue&type=script&lang=ts&"
export * from "./reporteHuellaCarbono.vue?vue&type=script&lang=ts&"
import style0 from "./reporteHuellaCarbono.vue?vue&type=style&index=0&id=8b104d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b104d6a",
  null
  
)

export default component.exports